import { Link } from "react-router-dom";
import heroImg from "../Assets/hero-botanical.jpg";
// import practitionerImg from "../Assets/twd-botanical-BZkhm6pb.jpg";
import UseScrollAnimation from "../Elements/ScrollAnimation";
// import ReadySchedule from "./Page_Sections/readySchedule";
import {
  ArrowRight,
  Sparkles,
  Leaf,
  HeartPulse,
  // Baby,
  // ShieldPlus,
  // Activity,
  // Smile,
  // Wind,
  // Dumbbell,
} from "lucide-react";
// import AboutThePractitioner from "./Page_Sections/aboutThePractitioner";
// import ThreeTestimonials from "./Page_Sections/threeTestimonials";
import CCH_Logo from "../Assets/CCH_Logo.jpeg";
import NASH_Logo from "../Assets/NASH_Logo.jpeg";
import ServicesConditionsSupported from "./Page_Sections/servicesConditionsSupported";
// import HomePageConditionsSupported from "./Page_Sections/homePageConditionsSupported";

// const stats = [
//   { v: "15+", l: "Years of practice" },
//   { v: "1,000+", l: "Patients served" },
//   { v: "100%", l: "Individualized care" },
// ];

const pillars = [
  {
    icon: Leaf,
    title: "Classical Approach",
    desc: "Single-remedy, individualized prescriptions rooted in Hahnemann's original principles.",
  },
  {
    icon: HeartPulse,
    title: "Whole-Person Care",
    desc: "Mind, body, and spirit considered together — symptoms are seen as part of a larger picture.",
  },
  {
    icon: Sparkles,
    title: "Gentle & Lasting",
    desc: "Remedies that work with your body's vitality to support deep, sustainable healing.",
  },
];

// const treatmentAreas = [
//   {
//     icon: Baby,
//     title: "Infant/ Children’s Health: ",
//     conditions: [
//       "Colic",
//       "Teething discomfort",
//       "Reflux / spitting up",
//       "Sleep disturbances",
//       "Mild diaper rash",
//     ],
//   },
//   {
//     icon: ShieldPlus,
//     title: "Common Childhood Illnesses",
//     conditions: [
//       "Colds and coughs",
//       "Sore throat",
//       "Ear discomfort",
//       "Mild fevers",
//       "Seasonal allergies",
//       "Sinus congestion",
//     ],
//   },
//   {
//     icon: Activity,
//     title: "Skin Conditions",
//     conditions: ["Mild rashes", "Acne in teens", "Warts"],
//   },
//   {
//     icon: Smile,
//     title: "Digestive Issues",
//     conditions: [
//       "Constipation",
//       "Diarrhea",
//       "Gas / bloating",
//       "Nausea",
//       "Motion sickness",
//       "Appetite concerns",
//     ],
//   },
//   {
//     icon: HeartPulse,
//     title: "Behavioral & Emotional Concerns",
//     conditions: [
//       "Anxiety",
//       "Irritability",
//       "School stress",
//       "Sleep anxiety",
//       "Nail biting",
//       "Attention / focus concerns",
//     ],
//   },
//   {
//     icon: Wind,
//     title: "Respiratory Concerns",
//     conditions: ["Allergies", "Mild asthma support", "Recurrent colds"],
//   },
//   {
//     icon: Sparkles,
//     title: "Growth & Wellness",
//     conditions: [
//       "Immune support",
//       "General wellness",
//       "Recovery support after illness",
//       "Fatigue",
//     ],
//   },
//   {
//     icon: Dumbbell,
//     title: "Sports & Physical Complaints",
//     conditions: [
//       "Minor bruises",
//       "Muscle soreness",
//       "Injuries",
//       "Minor sprains",
//     ],
//   },
// ];

const Home = () => {
  UseScrollAnimation(); // ✅ just call it

  return (
    <div className="HomeParent">
      <div className="HomeBox">
        {/* Hero */}
        <section className="GentleRemedies_Section">
          <div className="GentleRemedies_SectionParent">
            <div className="GentleRemedies_SectionBox">
              <p className="GentleRemedies_Section_Title animate-top">
                <span className="GentleRemedies_Section_TitleTop">
                  The Wellness Destination{" "}
                </span>
                <span className="GentleRemedies_Section_TitleBottom">
                  Homeopathy, LLC
                </span>
              </p>

              <h1 className="GentleRemedies_Section_Heading animate-top">
                <span className="GentleRemedies_Section_HeadingMain">
                  Gentle remedies,
                </span>
                <span className="GentleRemedies_Section_HeadingItalic">
                  {" "}
                  profound healing.
                </span>
              </h1>

              <div className="GentleRemedies_Section_Buttons animate-top">
                <p className="GentleRemedies_Section_Content animate-top">
                  Personalized classical homeopathy for the whole person —
                  supporting your body's innate ability to restore balance,
                  naturally.
                </p>

                {/* <p className="GentleRemedies_Section_Content animate-top">
                  I earned my Bachelor’s degree in Homeopathic Medicine and
                  Surgery (BHMS) from Dr. NTR University of Health Sciences,
                  India, and an MBA from Penn State University. I also completed
                  a Diploma in Homeopathy (DiHom) at the International Academy
                  of Classical Homeopathy (IACH) in Greece under Prof. George
                  Vithoulkas, and graduated from the American Medical College of
                  Homeopathy (AMCH) at PIHMA.
                </p>

                <p className="GentleRemedies_Section_Content animate-top">
                  As a Board Certified Classical Homeopath (CCH) and Registered
                  member of the North American Society of Homeopaths (RSHom NA),
                  I am passionate about helping clients of all ages through
                  individualized, holistic care for both chronic and acute
                  conditions.
                </p> */}

                <p className="YourPractitioner_Section_Title animate-top">
                  Your Practitioner
                </p>

                <h2 className="YourPractitioner_Section_Heading animate-top">
                  Care that begins with truly being heard.
                </h2>

                <p className="YourPractitioner_Section_Content animate-top">
                  {/* With over 25 years of classical homeopathic practice, */}
                  {/* Dedicated to healing through Homeopathy for Over Two Decades,
                  I partner with each client to understand the unique way
                  symptoms appear in their life — and to find the single remedy
                  that resonates most deeply. */}
                  Every individual is unique and has a story of their own. I
                  take the time to listen carefully to your symptoms,
                  experiences, and overall health picture. Using a classical
                  homeopathic approach, I seek to understand you as a whole
                  person and identify the single remedy that most closely
                  matches your unique pattern of symptoms, supporting your
                  journey toward greater balance and well-being.
                </p>
                <b className="YourPractitioner_Section_Content YourPractitioner_Section_Content00 animate-top">
                  {/* Suneetha Kasani B.H.M.S., M.B.A., DiHom-IACH., CCH., RSHom(NA) */}
                  <h2 className="YourPractitioner_Section_Heading00 animate-top">
                    Suneetha Kasani
                  </h2>
                  Board-Certified Classical Homeopathic Practitioner
                  <br />
                  BHMS | MBA | DiH(IACH) | CCH | RSHom(NA)
                </b>

                <div className="CCHandNASH_LogoDiv00">
                  <Link
                    to="/your-practitioner"
                    className="YourPractitioner_Section_Button01 animate-top"
                  >
                    <span>Meet your practitioner</span>

                    <ArrowRight className="YourPractitioner_Section_Button01_ArrowRight" />
                  </Link>
                </div>

                <Link
                  to="/contact-us"
                  className="GentleRemedies_Section_Button01 animate-top"
                >
                  <span>Book Appointment Today</span>

                  <ArrowRight className="GentleRemedies_Section_Button01_ArrowRight" />
                </Link>
              </div>

              <div className="GentleRemedies_Section_Buttons GentleRemedies_Section_Buttons00 animate-top">
                <div className="GentleRemedies_Section_ContentButtons">
                  <span className="GentleRemedies_Section_Content">
                    In-person and tele-health services
                  </span>

                  <Link
                    to="/services"
                    className="GentleRemedies_Section_Button02 animate-top"
                  >
                    Explore Services
                    <ArrowRight className="GentleRemedies_Section_Button01_ArrowRight" />
                  </Link>
                </div>
              </div>
              <div className="CCHandNASH_LogoDiv">
                <img
                  src={CCH_Logo}
                  alt="CCH_Logo"
                  className="CCH_Logo"
                  fetchPriority="high"
                  loading="eager"
                />

                <img
                  src={NASH_Logo}
                  alt="NASH_Logo"
                  className="NASH_Logo"
                  fetchPriority="high"
                  loading="eager"
                />
              </div>
            </div>

            <div
              initial="hidden"
              animate="show"
              className="GentleRemedies_ImageHighlight animate-top"
            >
              <div className="GentleRemedies_ImageDiv">
                <img
                  src={heroImg}
                  alt="GentleRemedies_ImageheroImg"
                  className="GentleRemedies_Image"
                  fetchPriority="high"
                  loading="eager"
                />
              </div>

              <div className="GentleRemedies_Section_Highest animate-top">
                <span className="GentleRemedies_Section_HighestContent">
                  <span className="GentleRemedies_Section_HighestIcon01">
                    {"\u00A7"}
                  </span>{" "}
                  "The highest ideal of cure is rapid, gentle and permanent
                  restoration of the health, or removal and annihilation of the
                  disease in its whole extent, in the shortest, most reliable,
                  and most harmless way, on easily comprehensible principles."
                </span>

                <span className="GentleRemedies_Section_HighestName">
                  <span>— Dr. Samuel Hahnemann</span>{" "}
                  <span>(Founder of homeopathy)</span>
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* Pillars */}
        <section className="Practice_Section">
          <div className="Practice_SectionBox">
            <div className="Practice_Section_TitleHeadingContent animate-top">
              <p className="Practice_Section_Title animate-top">
                Our Philosophy
              </p>

              <h1 className="Practice_Section_Heading animate-top">
                <span className="Practice_Section_HeadingItalic animate-top">
                  A practice rooted in listening.
                </span>
              </h1>

              <p className="Practice_Section_Content animate-top">
                Every consultation begins with your story — because lasting
                healing requires understanding the whole person, not just the
                symptom.
              </p>
            </div>

            <div className="Practice_Section_HighlightsBox animate-top">
              {pillars.map((p) => (
                <article
                  key={p.title}
                  className="Practice_Section_HighlightBox animate-top"
                >
                  <p.icon
                    className="Practice_Section_HighlightBox_Icon animate-top"
                    strokeWidth={1.5}
                  />

                  <h3 className="Practice_Section_HighlightBox_Heading animate-top">
                    {p.title}
                  </h3>

                  <p className="Practice_Section_HighlightBox_Description animate-top">
                    {p.desc}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Treatment Areas */}
        {/* <section className="TreatmentAreas_Section Practice_Section">
          <div className="TreatmentAreas_SectionParent Practice_SectionBox">
            <div className="TreatmentAreas_Section_TitleBox Practice_Section_TitleHeadingContent animate-top">
              <p className="TreatmentAreas_Section_Title Practice_Section_Title animate-top">
                Conditions We Support
              </p>

              <h2 className="TreatmentAreas_Section_Heading Practice_Section_Heading animate-top">
                Compassionate care for children, teens, and families.
              </h2>

              <p className="TreatmentAreas_Section_Content Practice_Section_Content animate-top">
                We provide individualized homeopathic support for a wide range
                of everyday health concerns, emotional wellness challenges, and
                recovery needs through a gentle, holistic approach.
              </p>
            </div>

            <div className="TreatmentAreas_Section_Cards Practice_Section_HighlightsBox animate-top">
              {treatmentAreas.map((item) => (
                <div
                  key={item.title}
                  className="TreatmentAreas_Section_Card Practice_Section_HighlightBox animate-top"
                >
                  <item.icon
                    className="TreatmentAreas_Section_CardIcon Practice_Section_HighlightBox_Icon"
                    strokeWidth={1.7}
                  />

                  <h3 className="TreatmentAreas_Section_CardHeading Practice_Section_HighlightBox_Heading">
                    {item.title}
                  </h3>

                  <ul className="TreatmentAreas_Section_List Practice_Section_HighlightBox_Description">
                    {item.conditions.map((condition, index) => (
                      <li
                        key={index}
                        className="TreatmentAreas_Section_ListItem"
                      >
                        <span className="TreatmentAreas_Section_ListItem_Content">
                          {condition}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="TreatmentAreas_Section_Disclaimer TestimonialsHighlights_Section_BottomContentDiv animate-top">
              <p className="TreatmentAreas_Section_DisclaimerText TestimonialsHighlights_Section_BottomContent">
                Homeopathy is intended to support overall wellness and is not a
                substitute for emergency or necessary medical care.
              </p>
            </div>
          </div>
        </section> */}

        {/* Practitioner preview */}
        {/* <section className="YourPractitioner_Section">
          <div className="YourPractitioner_SectionParent">
            <div className="YourPractitioner_ImageDiv animate-top">
              <img
                src={practitionerImg}
                alt="YourPractitioner_ImagepractitionerImg"
                loading="eager"
                className="YourPractitioner_Image"
              />
            </div>

            <div className="YourPractitioner_SectionBox animate-top">
              <p className="YourPractitioner_Section_Title animate-top">
                Your Practitioner
              </p>

              <h2 className="YourPractitioner_Section_Heading animate-top">
                Care that begins with truly being heard.
              </h2>

              <p className="YourPractitioner_Section_Content animate-top">
                With over 25 years of classical homeopathic practice, I partner
                with each client to understand the unique way symptoms appear in
                their life — and to find the single remedy that resonates most
                deeply.
              </p>

              <div className="CCHandNASH_LogoDiv00">
                <Link
                  to="/your-practitioner"
                  className="YourPractitioner_Section_Button01 animate-top"
                >
                  <span>Meet your practitioner</span>

                  <ArrowRight className="YourPractitioner_Section_Button01_ArrowRight" />
                </Link>

                <div className="CCHandNASH_LogoDiv">
                  <img
                    src={CCH_Logo}
                    alt="CCH_Logo"
                    className="CCH_Logo"
                    fetchPriority="high"
                    loading="eager"
                  />

                  <img
                    src={NASH_Logo}
                    alt="NASH_Logo"
                    className="NASH_Logo"
                    fetchPriority="high"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* CTA */}
        {/* <ReadySchedule /> */}
        {/* <HomePageConditionsSupported /> */}

        <ServicesConditionsSupported />
      </div>
    </div>
  );
};

export default Home;
